const store = {
    state: {
        paletteId: 'product',
        listId: 'counter',
        //this(behind) following keys' value must not be Changed
        storageKey: 'dataset',
        moduleTag: 'data-module',
        lineTag: 'data-line',
        pointTag: 'data-point'
    }
};


export default store;



// WEBPACK FOOTER //
// ./src/store/market.js